var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pages[_vm.visibilityProp] && _vm.pages[_vm.visibilityProp].description)?_c('section',{staticClass:"about__section home_container last"},[_c('article',{domProps:{"innerHTML":_vm._s(_vm.pages[_vm.visibilityProp].description)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }